import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { media } from '../../mixins/media.js';
import { List } from '../List/List.js';

const SidebarNavigationPrimaryContainer = styled.nav.withConfig({
  componentId: "sc-1dgxs5u-0"
})(["width:", "px;width:100%;display:block;overflow:hidden;", ""], ({
  theme
}) => theme.components.sidebar.primaryNavigationWidthMobile, ({
  theme
}) => switchProp('selectedDepth', {
  1: css(["overflow:visible;width:", "px;", ""], ({
    theme
  }) => theme.components.sidebar.primaryNavigationWidthMobile, media.greaterThan('s')`
          width: ${theme.components.sidebar.primaryNavigationWidthDesktop}px;
        `),
  2: css(["overflow:visible;"])
}));
const SidebarNavigationPrimary = /*#__PURE__*/withTitan(({
  children,
  selectedDepth
}) => jsx(SidebarNavigationPrimaryContainer, {
  selectedDepth: selectedDepth,
  children: jsx(List, {
    spaceBetween: 0,
    variant: "vertical-stretch",
    children: children
  })
}), {
  name: 'SidebarNavigationPrimary'
});

export { SidebarNavigationPrimary };
//# sourceMappingURL=SidebarNavigationPrimary.js.map
